define.alias("checkout/components/seamless-checkout/trial-plans-modal", "calendar/components/seamless-checkout/trial-plans-modal");